import { ADMISSION_FORM_MODE_CREATE, ADMISSION_FORM_MODE_EDIT, PresetForm } from '@components/admission-form';
import { OfferFormDrawer } from '@components/offer-form-drawer';

import { type AdmissionPresetDrawerProps } from './admission-preset-drawer.type';

export const ADMISSION_PRESET_DRAWER_TEST_ID = 'admission-preset-drawer';

export const AdmissionPresetDrawer = ({
  isOpen,
  onClose,
  admissionType,
  preset,
  onSave,
  galleryController,
  isSaving = false,
  onAfterClose,
}: AdmissionPresetDrawerProps): JSX.Element => (
  <OfferFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    onAfterClose={onAfterClose}
    isSaving={isSaving}
    isEditing={!!preset}
    galleryController={galleryController}
    testId={ADMISSION_PRESET_DRAWER_TEST_ID}>
    {({ requestClose, setHasUnsavedChanges, galleryController: trackedGallery }) => (
      <PresetForm
        mode={preset ? ADMISSION_FORM_MODE_EDIT : ADMISSION_FORM_MODE_CREATE}
        admissionType={admissionType}
        preset={preset}
        onSave={onSave}
        onClose={requestClose}
        onDirtyChange={setHasUnsavedChanges}
        galleryController={trackedGallery}
        isSaving={isSaving || !isOpen}
      />
    )}
  </OfferFormDrawer>
);
